//openMainMenujsの書き換え

let closeMenuFn: (() => void) | null = null

// ハンバーガーメニューの開閉をセットアップする関数
export function setupGlobalNavMenu() {
  const openBtn = document.getElementById('hamburger') // 開くボタン
  const closeBtn = document.getElementById('closeMenuBtn') // 閉じるボタン
  const nav = document.querySelector<HTMLElement>('.global-nav')
  const overlay = document.getElementById('menuOverlay')

  // 必須要素がなければ何もしない
  if (!openBtn || !nav || !overlay) return

  const openMenu = () => {
    nav.classList.add('is-open')
    overlay.classList.add('is-active')
    document.body.classList.add('no-scroll')
  }

  const closeMenu = () => {
    nav.classList.remove('is-open')
    overlay.classList.remove('is-active')
    document.body.classList.remove('no-scroll')
  }

  // 外から呼べるように保持
  closeMenuFn = closeMenu

  // イベント登録
  openBtn.addEventListener('click', openMenu)
  closeBtn?.addEventListener('click', closeMenu)
  overlay.addEventListener('click', closeMenu)

  // Vue コンポーネントの unmount 時に呼ぶためのクリーンアップ関数を返す
  return () => {
    openBtn.removeEventListener('click', openMenu)
    closeBtn?.removeEventListener('click', closeMenu)
    overlay.removeEventListener('click', closeMenu)
  }
}

export function forceCloseGlobalNavMenu() {
  closeMenuFn?.()
}
